exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-media-container img {\r\n  margin-right: 20px;\r\n}\r\n.social-media-container div span {\r\n  margin-top: 20px;\r\n}\r\n.social-media-container i {\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n}\r\n.social-media-container div div {\r\n  width: 90%;\r\n  padding-left: 0px;\r\n}\r\n.extra-column-padding {\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n}\r\n\r\nspan.k-dropdown-wrap {\r\n  width: 100%;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/newsbrief/social-media/styles.css
// module id = 2642
// module chunks = 29